// Reusable Button Component
export default function Button({  children,  onClick,  type = "button",  variant = "primary",  isLoading = false,
  disabled = false, className = ""
}){
  const baseClasses = "w-full font-semibold py-3 rounded-xl transition-all active:scale-[0.98] disabled:opacity-70 text-sm flex items-center justify-center gap-2";
  
  const variantClasses = {
    primary: "bg-gradient-to-r from-amber-500 to-orange-500 text-white",
    secondary: "bg-white border border-gray-200 ",
    text: "flex items-center justify-center gap-1 text-xs text-amber-600  py-1.5"
  };
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
    >
      {isLoading ? (
        <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
      ) : (
        children
      )}
    </button>
  );
};